import AsyncBlockService from 'services/async-block-service';
var View = require('views/base/view');

import { KeybindingService, keys } from 'services/keybinding-service';
var LocaleService = require('services/locale-service');
var utils = require('lib/utils');
const AhoyService = require('services/ahoy-service');
import IconLoadService from 'services/icon-load-service';
const { Enter, Space } = keys;

var ResourceItemView = View.extend({
  template: require('./templates/resource-item'),
  className: 'resource-item',
  optionNames: [ 'blockModel' ],
  listen: {
    addedToParent: 'load'
  },
  regions: {
    video: '.video-container'
  },
  initialize: function() {
    if(this.model.get('requires_e_signature')) {
      this.$el.addClass('e-signature-required');
    }
    if(this.model.get('signed')) {
      this.$el.addClass('signed');
    }
    if(this.model.get('name')) {
      this.$el.addClass(utils.slugify(this.model.get('name')));
    }
    if(this.model.get('sub_type')) {
      this.$el.addClass(this.model.get('sub_type'));
    }
    if(!this.model.get('body') && this.model.get('requires_e_signature') && !this.blockModel.get('hide_esig') && this.model.get('url')) {
      this.model.set('body', LocaleService.t('defaultESigBody'));
    }
    IconLoadService.applyIcon('fal fa-times', `${this.blockModel.get('cid')}-${this.model.get('id')}`, 'fa-lg');
    utils.setHeadingLevel(this.model, this.blockModel.get('heading_level'), 'div');
    View.prototype.initialize.apply(this, arguments);
  },
  load: function() {
      if(this.model.get('video_url')) {
        AsyncBlockService.load([ 'video' ]).then(([ VideoView ]) => {
          var m = new Chaplin.Model({
            type: 'video',
            auto_play: false,
            options: _.defaults({
              metadataUrl: this.model.get('video_url'),
              customMediaHost: true
            }, this.blockModel.get('video_options'))
          });
          this.video = new VideoView({
            parent: this,
            region: 'video',
            model: m
          });

          this.subview('video', this.video);
          this.video.load();
          this.delegate('shown.bs.modal', `#resource-modal-${this.model.get('id')}`, () => {
            this.video.resume();
          });
        });
      }
      this.delegate('hidden.bs.modal', `#resource-modal-${this.model.get('id')}`, () => {
        if(this.model.get('video_url') && this.video) {
          this.video.pause();
        }
      });

      if(this.blockModel.has('name_required') && this.blockModel.get('name_required') === true) {
        const id = this.model.get('id');
        this.delegate('input', `#e-sign-resource-${id}-name`, e => {
          const $target = $(e.target);
          this.$el.find(`#e-sign-resource-${id}`).prop('disabled', ($target.val() === ''));
        });
      }

      this.delegate('click', '.e-sign-checkbox', function(e) {
        var checkbox = $(e.currentTarget);
        this.model.set('signed', true);
        checkbox.addClass('signing');
        $('.choices__wrapper').children('label').addClass('choices__label--checked');
        checkbox.prop('disabled', true);
        AhoyService.track('resource-item', {action: 'clicked', type: 'choices__input', target: e.currentTarget});

        EF.ContentProvider.ResourceService.save(this.model)
        .then(response => {
          // Ensure that the model is successfully signed
          if(this.model.get('signed') && response) {
            this.model.set('signature_confirmed',true);
            this.$el.removeClass('signing');
            this.$el.addClass('signed');
            const signedCaption = this.model.has('e_sign_caption_signed')
              ? this.model.has('e_sign_caption_signed')
              : LocaleService.t('signedMessage');
            checkbox.siblings('label').addClass('e-sign-label--signed');
            checkbox.siblings('label').find('span').text(signedCaption);
            const $signedNameInput = this.$el.find(`#e-sign-resource-${this.model.get('id')}-name`);
            $signedNameInput.prop('disabled', true);
            this.model.set('signed_name', $signedNameInput.val());
          } else {
            e.stopPropagation();
            checkbox.prop('disabled', false);
            checkbox.prop('checked',false);
            $('.choices__wrapper').children('label').addClass('choices__label');
          }

          $('.choices__wrapper').children('label').removeClass('choices__label--checked');
        });
      });
      this.delegate('keydown', '.e-sign-label', function(e) {
        KeybindingService.with(e)
          .bind([Enter, Space], () => {
            this.$el.find('.e-sign-checkbox').trigger('click');
          }
        );
      });
      if(this.model.get('requires_link_click')) {
        if(this.model.get('requires_e_signature')) {
          this.delegate('click', '.resource-link', (e) => {
            AhoyService.track('resource-item', {action: 'clicked', type: 'requires_link_click', target: e.currentTarget});
            if(!this.model.get('signed')) {
              if(this.blockModel.get('name_required')) {
                this.$el.find('.e-sign-resource-name-input').prop('disabled', false);
              } else {
                this.$el.find('.e-sign-checkbox').prop('disabled', false);
              }
            }
          });
        } else {
          this.$el.addClass('link-click-required');
          this.delegate('click', '.resource-link', (e) => {
            AhoyService.track('resource-item', {action: 'clicked', type: 'link-click-required', target: e.currentTarget});
            this.model.set('link_clicked', true);
            this.$el.addClass('link-clicked');
          });
        }
      }
      if(this.model.get('requires_body_view')) {
        this.$el.addClass('body-view-required');
        this.delegate('shown.bs.modal', `#resource-modal-${this.model.get('id')}`, () => {
          this.model.set('body_viewed', true);
          this.$el.addClass('body-viewed');
        });
      }
      this.delegate('click', '[data-toggle]', function(e) {
        AhoyService.track('resource-item', {action: 'clicked', currentTarget: e.currentTarget});
      });
  },
  getTemplateData: function() {
    var blockData = this.blockModel.serialize();
    var data = $.extend(true, blockData, this.model.serialize());
    if((data.body || data.requires_e_signature) && data.show_modal !== false) {
      data.show_modal = true;
    }
    return data;
  }
});

module.exports = ResourceItemView;
